import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { CommonmastersService } from "../../../commonmasters/commonmasters.service";
import { SavingstransactionService } from "../../shared/savingstransaction.service";
import { SavingsService } from "../../shared/savings.service";

@Component({
  selector: 'app-savingsreceipts',
  templateUrl: './savingsreceipts.component.html',
  styleUrls: ['./savingsreceipts.component.css']
})

export class SavingsreceiptsComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  SavingReceiptsNo: number;
  PaymentTypeList: [''];
  BankLedgerList: [''];
  DepositsList: [''];

  SavingTransactionId: number;
  Address : string;
  Isreadonly : boolean = false;
  BankVisibility: boolean = false;
  CustomerName: string;

  constructor(public savingstransactionService: SavingstransactionService,
    private savingsService: SavingsService,
    private commonmastersService: CommonmastersService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.SavingTransactionId = +  params['Id'];  // (+) converts string 'id' to a number
    });

    this.FetchDepositNoList()
    this.GetPaymentTypeList();
    this.GetBankLedgerList();

    if (Number.isNaN(this.SavingTransactionId)) {
      this.resetForm();
      this.savingstransactionService.selectedSavingsTransaction.Id = 0;
      this.savingstransactionService.selectedSavingsTransaction.Flag = 1;
      this.savingstransactionService.selectedSavingsTransaction.IsActive = true;
      this.AddButtonText = "Save";
      this.Isreadonly = false;
      this.GetAutogeneratedNumber();
    }
    else {
      this.savingstransactionService.selectedSavingsTransaction.Id = +this.SavingTransactionId;
      this.savingstransactionService.selectedSavingsTransaction.Flag = 2;
      // this.savingstransactionService.selectedSavingsTransaction.IsActive = 1;
      this.AddButtonText = "Edit & Save";
      this.Isreadonly = true;
      this.GetSavingTransactionByNo();
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

      this.savingstransactionService.selectedSavingsTransaction = {

        Id : 0,
        TransactionNo: 0,
        SavingsId : 0,
        // CentreId :0,
        TransactionDate   : JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
        CollectionAmount : null,
        PrincipleAmount : null,
        InterestAmount   : null,
        BalanceAmount : 0,
        LateFeeAmount : 0,
        InstallmentNo : 0,
        IsPartPayment : true,
        IsPreclosure : false,
        IsAccruedAmount : false,
        IsSavingsclosed :  false,
        IsReceiptAmount :  true,
        PaymentTypeId: 0,
        PaymentBankId : 0,
        ChequeNo : null,
        Remarks  : null,

        ReportName: null,

        EmployeeId: null,
        EmployeeBranchId: null,
        CompanyId: null,
        SaasId: null,
        CreatedDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
        ModifiedDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
        IsActive: true,
        Flag : 1,
        IsOpening:false,
    }
  }
  
  
  GetAutogeneratedNumber(): any {
    if (this.savingstransactionService.selectedSavingsTransaction.TransactionNo == 0) { 
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.savingstransactionService.selectedSavingsTransaction.TransactionNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
  }

  GetSavingTransactionByNo() {

    if (this.savingstransactionService.selectedSavingsTransaction.Id !== 0) {
      this.savingstransactionService.FetchSavingsTransactionByNo(this.savingstransactionService.selectedSavingsTransaction)
        .subscribe(data => {
          this.savingstransactionService.selectedSavingsTransaction = data;
          this.savingstransactionService.selectedSavingsTransaction.Flag = 2;
        })
    }
  }

  FetchDepositNoList() {
    this.savingstransactionService.FetchDepositNoList()
    .subscribe(data => {
      this.DepositsList = data;
    })
  }

  GetPaymentTypeList() {
    this.commonmastersService.FetchPaymentMode().subscribe(data => {
      this.PaymentTypeList = data;
    })
  }

  GetBankLedgerList(){ 
    this.savingsService.FetchBankLedgerList()
    .toPromise()
    .then(data => {
      this.BankLedgerList = data;
    })
  }

  onSubmit(form: NgForm) {
 
    if (this.savingstransactionService.selectedSavingsTransaction.SavingsId != 0) {
  
      this.savingstransactionService.selectedSavingsTransaction.IsReceiptAmount = true;
      this.savingstransactionService.selectedSavingsTransaction.Remarks ="Savings Receipt";
      this.savingstransactionService.IUDSavingstransaction(form.value)
        .subscribe(data => {
          // this.resetForm(form);
          this.router.navigate(['/savingsreceiptslist']);
        })
    }
    else{
      this.ErrorText = 'Please select the Savings No.'
    }
  }

  ShowBankList(Id: number) {
    if (Id == 2)//Bank
    {
      this.BankVisibility = true;
    }
    else {
      this.BankVisibility = false;
    }
  }

  public changeDepositNo(SavingsId) {

    for (var i = 0; i < this.DepositsList.length; i++) {
      if (this.DepositsList[i]["Id"] == SavingsId) {
        this.CustomerName = this.DepositsList[i]["CustomerName"];
        this.Address = this.DepositsList[i]["CustomerAddress"];
      }
    }
  }

}
